export const MESSAGES = {
  REQUEST_ERROR: "Fail to fetch site lists",
  NO_REQUESTS_AVAILABLE: "No Sites",
  DELETE_SUCCESS: "Site deleted successfully",
  DELETE_ERROR: "Failed to delete site",
};

export const SITE_LIST_COLUMNS = [
  "name",
  "client_name",
  "client_email",
  "client_phone",
  "estimated_start_date",
  "estimated_end_date",
  "actions",
];


export const SITE_LIST_LABELS = {
  name: "Site Name",
  client_name: "Client Name",
  client_email: "Client Email",
  client_phone: "Client Phone",
  estimated_start_date: "Start Date",
  estimated_end_date: "End Date",
  actions: "Actions"
};

export const ROLES = {
  INCHARGE: "INCHARGE",
  PROJECT_INCHARGE: "PROJECT_INCHARGE",
};

export const SITE_NAME_REQUIRED = "Site name is required"
export const CLIENT_NAME_REQUIRED = "Client name is required"
export const INVALID_MAIL = "Invalid Mail"
export const CLIENT_MAIL_REQUIRED = "Client email is required"
export const CLIENT_ADDRESS_REQUIRED = "Client address is required"
export const MOBILE_REQUIRED = "Client phone is required"
export const MOBILE_VALIDATION = "Must be exactly 10 digits"
export const START_DATE = "Start date is required"
export const END_DATE = "End date is required"
export const DATE_VALIDATION = "End date can't be before start date"
export const GEOFENCE_VALIDATION = "Please draw a geofence on the map."
export const SITE_NOT_FOUND = "Site not found."
export const SITE_LOAD_FAILED = "Failed to load site data"
export const SITE_UPDATE_SUCCESS = "Site Update Successfully"
export const SITE_CREATE_SUCCESS = "Site created successfully"
export const SITE_SAVE_FAILED = "Failed to save site"
export const SITE_INCHARGE_REQUIRED = "Site incharge is required"
export const PROJECT_INCHARGE_REQUIRED = "Project incharge is required"
export const CONFIRIM_DELETE = "Are you sure you want to delete this site?."
export const LOAD_INCHARGE_FAILED = "Failed to load incharge users"
export const LOAD_TAG_OPTIONS_FAILED = "Failed to load tag options"
export const LOAD_USERS_FAILED = "Failed to load users"
export const GEOFENCE_ERROR = "Failed to parse geofence:"

export const VIEW_MODE = "view"
export const ADD_MODE = "add"
export const EDIT_MODE = "edit"
